import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined'
import { Button, DialogContentText } from '@mui/material'
import Box from '@mui/material/Box'
import CheckboxComponent from 'components/checkbox'
import ModalConfirmComponent from 'components/modal-confirm'
import NavComponent from 'components/nav'
import TextComponent from 'components/text'
import React, { useState } from 'react'
import { baseURL } from 'utils/constants'

interface UploadButtonProps {
  isShow: boolean
  onActionCancel: () => void
  onActionSubmit: (file: File) => void
}

const FileUpload: React.FC<UploadButtonProps> = ({ isShow, onActionCancel, onActionSubmit }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [isConsent, setIsConsent] = useState(false)

  // Function to handle file selection
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (files && files.length > 0) {
      setSelectedFile(files[0])
    }
  }

  // Function to handle file upload
  const handleFileUpload = async () => {
    if (selectedFile) {
      onActionSubmit(selectedFile)
      setSelectedFile(null)
      setIsConsent(false)
    }
  }

  // Function to handle dialog close
  const handleDialogClose = () => {
    setSelectedFile(null)
    setIsConsent(false)
    onActionCancel()
  }

  return (
    <div>
      {/* Dialog for Selecting File and Starting Upload */}
      <ModalConfirmComponent
        isShow={isShow}
        title={`Select a file to upload`}
        body={
          <>
            {/* Selected Filename */}
            {selectedFile?.name ? <DialogContentText>{selectedFile.name}</DialogContentText> : <></>}
            {/* Button to select file */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <input
                accept={'.csv'}
                id='contained-button-file'
                type='file'
                onChange={handleFileSelect}
                style={{ display: 'none' }}
              />
              <label htmlFor='contained-button-file'>
                <Button
                  variant='contained'
                  component='span'
                  color={selectedFile?.name ? 'warning' : 'secondary'}
                  sx={{
                    height: '44px',
                    minWidth: '112px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '12px',
                    mb: '15px',
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    textTransform: 'none',
                  }}
                >
                  Browse
                </Button>
              </label>
            </Box>
            {selectedFile?.name ? (
              <Box display='flex' flexDirection='row' justifyContent='center' paddingTop={2}>
                <CheckboxComponent
                  isChecked={isConsent}
                  onClick={() => setIsConsent(!isConsent)}
                  label={
                    <div>
                      I confirm that I have the authority to share this parent data with Carpool School Inc. This
                      information will be governed by the Carpool School Inc.{' '}
                      <span style={{ color: '#beac48', fontWeight: 'bold', textDecoration: 'underline' }}>
                        <NavComponent
                          href={`${baseURL}/home/index.html#privacy`}
                          text='Privacy Policy'
                          isOpenNewTab={true}
                        />
                      </span>
                      .
                    </div>
                  }
                />
              </Box>
            ) : (
              <label htmlFor='contained-button-file2'>
                {/*******************DOWNLOAD SAMPLE CSV FILE********************/}
                <TextComponent size='body2'>Please make sure the uploaded file is in right format</TextComponent>
                <Button
                  data-testid='download-csv-button'
                  startIcon={<DownloadForOfflineOutlinedIcon />}
                  href='/sample_users.csv'
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label='Download sample CSV file'
                  sx={{ marginTop: '12px', cursor: 'pointer' }}
                >
                  Download Sample CSV
                </Button>
              </label>
            )}
          </>
        }
        actionIcon={'yellowUploadIcon'}
        actionText={'Upload'}
        onActionCancel={handleDialogClose}
        onActionSubmit={handleFileUpload}
        isActionSubmitDisable={!isConsent}
      />
    </div>
  )
}

export default FileUpload
